import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faTelegram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import { handleCopyToClipboard } from "../../../shared/utils/commonUtils";
import { getTelegramLink, getWhatsappLink } from "../utils/share";

const ICON_CLASS = "h-10 lg:h-7 hover:opacity-70 transition active:h-5";

interface BlogShareLinksProps {
    url: string; // Full public URL of the article
}

// Copy link, Telegram and WhatsApp buttons
const BlogShareLinks = ({ url }: BlogShareLinksProps) => {
    const { t } = useLanguage();

    return (
        <ul className="flex justify-center gap-10 lg:gap-6 items-center list-none text-md">
            <li>
                <button
                    type="button"
                    onClick={() => handleCopyToClipboard(url)}
                    aria-label={t.blog.copyLink}
                >
                    <FontAwesomeIcon icon={faLink} className={ICON_CLASS} />
                </button>
            </li>
            <li>
                <a
                    href={getTelegramLink(url, t.blog.shareText)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Telegram"
                >
                    <FontAwesomeIcon icon={faTelegram} className={ICON_CLASS} />
                </a>
            </li>
            <li>
                <a
                    href={getWhatsappLink(url, t.blog.shareText)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp"
                >
                    <FontAwesomeIcon icon={faWhatsapp} className={ICON_CLASS} />
                </a>
            </li>
        </ul>
    );
};

export default BlogShareLinks;